// src/App.js
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Chatbot from "./components/ChatbotPage/Chatbot";

const App = () => {
  const [isIframe, setIsIframe] = useState(true);

  useEffect(() => {
    if (window.self === window.top) {
      setIsIframe(false);
    }
  }, []);

  if (!isIframe) {
    return (
      <p className="min-h-screen flex items-center justify-center">
        404 Not Found
      </p>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Chatbot />} />
    </Routes>
  );
};

export default App;
